module.exports = __webpack_public_path__ + "img/task-4.bb03fdb4.png";